import React from 'react'

const Button = (props) => {
    const { employee, clients } = props;
    return (
        <React.Fragment>
            {employee? <a className="btn btn-secondary" href={`/desk/clients/${clients.id}/employees/${employee.id}`}>従業員を表示</a> :
                <a className="btn btn-secondary disabled" aria-disabled="true" href="#">従業員がいません</a>  }
        </React.Fragment>
    )
}

export default Button
